import classNames from "classnames";
import * as React from "react";
import { useState } from "react";
import CancelSubscription from "../../components/CancelSubscription";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import SmartButton from "../../components/SmartButton";
import "./styles.scss";
import { NewPayment } from "../../store/payment";
import {
    PAYMENT_PLANS,
    PaymentPlan
} from "../../generated/lib-domain/paymentPlan";
import { PlanPrice } from "../../components/PlanPrice";
import PriceDifference from "../../components/Messages/PriceDifference";
import { SubscriptionEnum } from "../../generated/UserAPIAgent";

interface ConfirmTransitionProps {
    cancellationDeadLine: string;
    subscriptionEndDate: string;
    creditStartDate: string;
    onPaymentTransition: () => void;
    isLoading: boolean;
    isChangeSubscription: boolean;
    selectedPayment: NewPayment;
    onChangeSubscription: () => void;
}

const ConfirmTransition = (props: ConfirmTransitionProps) => {
    const [isCancelFlowVisible, setIsCancelFlowVisible] = useState(false);
    const cancelFlow = () => {
        return (
            <div className="cancel-subscription-wrapper">
                <div
                    className={classNames({
                        toggle: true,
                        open: isCancelFlowVisible
                    })}
                    onClick={() => setIsCancelFlowVisible(!isCancelFlowVisible)}
                >
                    サブスクリプションの解約方法
                </div>
                {isCancelFlowVisible && <CancelSubscription />}
            </div>
        );
    };
    const changeSubscription = () => {
        return (
            <>
                <Headline>
                    {
                        PAYMENT_PLANS.find(
                            (plan) => plan.id === PaymentPlan.Standard1MCard9800
                        ).title
                    }
                    に登録して
                    <br />
                    クレジットカード決済に変更する
                </Headline>
                <section className="confirm-transition">
                    <div className="change-subscription">
                        本手続きが完了した時点で
                        <br />
                        {
                            PAYMENT_PLANS.find(
                                (plan) =>
                                    plan.id ===
                                    props.selectedPayment.paymentPlanId
                            ).title
                        }
                        に変更となります。
                    </div>
                    <aside className="cation-wrapper">
                        <div className="cation">
                            <p>
                                すぐにライトプランのAppleサブスクリプションを解約してください
                            </p>
                        </div>
                    </aside>
                    {cancelFlow()}
                    <PriceDifference
                        subscription={SubscriptionEnum.STANDARD}
                        addText={false}
                        isNotPaidMember={false}
                    />
                    <SmartButton
                        mode="primary"
                        isLoading={props.isLoading}
                        onClick={() => props.onChangeSubscription()}
                    >
                        <PlanPrice
                            selectedPaymentPlan={props.selectedPayment}
                            cardPaymentPlan={null}
                        />
                        <br />
                        クレジットカード決済に変更する
                    </SmartButton>
                </section>
            </>
        );
    };
    const noChangeInSubscription = () => {
        return (
            <>
                <Headline>クレジットカード決済移行の確認</Headline>
                <section className="confirm-transition">
                    <p>
                        {props.cancellationDeadLine}
                        午前0時までに、お客様がご使用のAppleの端末より、Apple
                        サブスクリプションの解約をしてください。なお、解約を先に済ませてもサービスをご利用できる期間に変わりはございません。安心してご解約ください。
                    </p>
                    <p className="caption">
                        期限までにApple
                        サブスクリプションを解約されなかった場合は、引き続きAppleサブスクリプションで決済されます。
                        クレジットカード決済への移行は行われません。
                    </p>
                    {cancelFlow()}
                    <div className="transition-schedule">
                        <dl>
                            <div className="row">
                                <dt>Apple サブスクリプション終了予定日</dt>
                                <dd>{props.subscriptionEndDate}</dd>
                            </div>
                            <div className="row">
                                <dt>クレジットカード決済開始予定日</dt>
                                <dd>{props.creditStartDate}</dd>
                            </div>
                        </dl>
                    </div>

                    <div className="user-action">
                        <SmartButton
                            mode="primary"
                            isLoading={props.isLoading}
                            onClick={() => props.onPaymentTransition()}
                        >
                            移行手続きを実行する
                        </SmartButton>
                    </div>
                </section>
            </>
        );
    };

    return (
        <MainLayout>
            {props.isChangeSubscription
                ? changeSubscription()
                : noChangeInSubscription()}
        </MainLayout>
    );
};

export default ConfirmTransition;
